module.exports = __webpack_public_path__ + "static/media/21_B.e894c247.png";